module.exports = __webpack_public_path__ + "img/spider.f3781208.png";